module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/app/lang/en.json
// module id = grrI
// module chunks = 1